module.exports = __webpack_public_path__ + "img/Group 1504775666.c4e8f100.svg";